import './App.css';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { FrappeProvider } from 'frappe-react-sdk';
import { Toaster } from 'react-hot-toast';
import { useEffect } from 'react';

// Pages
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import SessionDetail from './pages/SessionDetail';
import UserAccount from './pages/UserAccount';
import RoleChecker from './pages/RoleChecker';
import AuthRoute from './components/AuthRoute';
import Guide from './pages/Guide';
import Analytics from './pages/Analytics';
import Assessments from './pages/Assessments';
import AssessmentDetail from './pages/Assessments/AssessmentDetail';

function AppStatic() {
    // Simple effect to ensure light theme
    useEffect(() => {
        // Remove dark class if present
        document.documentElement.classList.remove('dark');
        document.body.classList.remove('dark');
    }, []);

    return (
        <div className="light-theme-wrapper" style={{ backgroundColor: '#f9fafb', minHeight: '100vh', fontFamily: 'system-ui, sans-serif' }}>
            <FrappeProvider>
                <Toaster position="top-right" />
                <Router>
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route path="/dashboard" element={
                            <AuthRoute>
                                <Dashboard />
                            </AuthRoute>
                        } />
                        <Route path="/session/:sessionName" element={
                            <AuthRoute>
                                <SessionDetail />
                            </AuthRoute>
                        } />
                        <Route path="/account" element={
                            <AuthRoute>
                                <UserAccount />
                            </AuthRoute>
                        } />
                        <Route path="/guide" element={<Guide />} />
                        <Route path="/analytics" element={
                            <AuthRoute>
                                <Analytics />
                            </AuthRoute>
                        } />
                        <Route path="/assessments" element={
                            <AuthRoute>
                                <Assessments />
                            </AuthRoute>
                        } />
                        <Route path="/assessments/:assessmentId" element={
                            <AuthRoute>
                                <AssessmentDetail />
                            </AuthRoute>
                        } />
                        <Route path="/role-checker" element={
                            <AuthRoute>
                                <RoleChecker />
                            </AuthRoute>
                        } />
                        <Route path="/" element={<Navigate to="/dashboard" replace />} />
                        {/* Catch-all route for debugging */}
                        <Route path="*" element={
                            <div className="min-h-screen flex items-center justify-center bg-gray-50">
                                <div className="text-center">
                                    <h1 className="text-2xl font-bold text-gray-900 mb-4">Route Not Found</h1>
                                    <p className="text-gray-600 mb-4">The requested route was not found in static mode.</p>
                                    <div className="mt-4">
                                        <a href="#/login" className="text-blue-600 hover:text-blue-800">Go to Login</a>
                                        {' | '}
                                        <a href="#/dashboard" className="text-blue-600 hover:text-blue-800">Go to Dashboard</a>
                                    </div>
                                </div>
                            </div>
                        } />
                    </Routes>
                </Router>
            </FrappeProvider>
        </div>
    );
}

export default AppStatic;
